// Step slugs for /offer-wizard/[step]. Drives getStaticPaths in
// pages/offer-wizard/[[...slug]].tsx and the order the wizard moves
// through. Add new steps here in order.
//
// Naming note: the route lives at `/offer-wizard` (user-facing) but the
// experiment that delivers this flow is `organic_chat` (the GrowthBook
// flag + the folder under Experiments/). The steps belong to the
// experiment, hence ORGANIC_CHAT_STEPS.
export const ORGANIC_CHAT_STEPS = [
  'service',
  'devices',
  'usage',
  'results',
] as const;

export type OrganicChatStep = (typeof ORGANIC_CHAT_STEPS)[number];

export const ORGANIC_CHAT_STEP_LABELS: Record<OrganicChatStep, string> = {
  service: 'Take the quiz',
  devices: 'Take the quiz',
  usage: 'Take the quiz',
  results: 'Choose your plan',
};
